import React from 'react';

function HomeAbout() {

    return (

        <section className="about">
            <div className="container text-center">

                <h2>
                    We teach React
                </h2>

                <p>
                    React is a JavaScript library created by Facebook. It is currently one of the most popular
                    libraries for building web applications.
                    It is used by many Fortune-500 companies including Instagram, Airbnb, BBC and Dropbox.
                    We know React inside out. Want to learn React in a real life classroom? Come and follow a
                    training with us!
                </p>

                <div className="row stats-row">
                    <div className="stats-col text-center col-md-4 col-sm-6">
                        <div className="circle">
                            <span className="stats-no" data-toggle="counter-up">4.8</span>
                            Average rating<br />
                            4.8****/5
                        </div>
                    </div>

                    <div className="stats-col text-center col-md-4 col-sm-6">
                        <div className="circle">
                            <span className="stats-no" data-toggle="counter-up">3000+</span>
                            Students since 1996
                        </div>
                    </div>

                    <div className="stats-col text-center col-md-4 col-sm-6">
                        <div className="circle">
                            <span className="stats-no" data-toggle="counter-up">7</span>
                            Countries since 2019
                        </div>
                    </div>


                </div>
            </div>
        </section>

    );
}

export default HomeAbout;
